import { Divider, Input, Textarea } from '@chakra-ui/react';
import { useIntl } from 'react-intl';

interface ProfileInfoComponentProps {
    username: string;
    aboutMe: string;
    onUsernameChange(setState: React.SetStateAction<string>): void;
    onAboutMeChange(setState: React.SetStateAction<string>): void;
}

export const ProfileInfoComponent = (props: ProfileInfoComponentProps) => {
    const localStoragePrefix = 'ManageCommunications';

    const intl = useIntl();

    return (
        <>
            <Divider className="profile-info-divider" />
            <Input
                className="profile-info-input profile-info-input-username"
                defaultValue={props.username}
                placeholder={intl.formatMessage({
                    id: 'profile_info.no_username_placeholder',
                    defaultMessage: 'Username...',
                })}
                onChange={(e) => props.onUsernameChange(e.target.value)}
            />
            <Divider className="profile-info-divider" />
            <Textarea
                className="profile-info-input profile-info-input-about-me"
                defaultValue={props.aboutMe}
                placeholder={intl.formatMessage({
                    id: 'profile_info.no_about_me_placeholder',
                    defaultMessage: 'About Me...',
                })}
                onChange={(e) => props.onAboutMeChange(e.target.value)}
            />
            <Divider className="profile-info-divider" />
        </>
    );
};
